/**
 * Inputs: in-flight GET generation vs completed mutations.
 * Outputs: whether a remote trip may replace the on-screen document and ETag.
 */

export function shouldApplyRemoteTrip(input: {
  incomingRevision: number;
  appliedRevision: number | null;
  mutationSeqAtStart: number;
  mutationSeqNow: number;
  conflictOpen: boolean;
  isInitialLoad: boolean;
  saveInFlight?: boolean;
}): boolean {
  if (input.conflictOpen && !input.isInitialLoad) return false;
  if (input.saveInFlight && !input.isInitialLoad) return false;
  if (input.mutationSeqNow !== input.mutationSeqAtStart) return false;
  if (input.appliedRevision != null && input.incomingRevision < input.appliedRevision) return false;
  return true;
}
